import type { ReactNode } from 'react'
import { useEffect } from 'react'

import { useTheme } from '../../contexts/ThemeContext'

type Props = {
  backgroundColor?: string
  children?: ReactNode
}

export default function PageBackground20({
  backgroundColor,
  children,
}: Readonly<Props>) {
  const { setBackgroundColorOverride, clearBackgroundColorOverride } =
    useTheme()

  useEffect(() => {
    setBackgroundColorOverride(backgroundColor)

    return () => {
      clearBackgroundColorOverride()
    }
  }, [
    backgroundColor,
    clearBackgroundColorOverride,
    setBackgroundColorOverride,
  ])

  return <>{children}</>
}
